import { ITenantMembership } from '../entities/ITenantMembership';
import { SignInStepEnum } from '../enums/SignInStepEnum';
import { httpClient } from './helper/httpClient';

export interface ISignInParams {
  email: string;
  password: string;
}

export interface ISignInResponse {
  step: SignInStepEnum;
  membership?: ITenantMembership;
  memberships?: ITenantMembership[];
  accessToken?: string;
  refreshToken?: string;
}

export interface ISignUpParams {
  name: string;
  email: string;
  password: string;
}

export interface ISignUpConfirmationParams {
  email: string;
  code: string;
}

export interface IForgotPasswordParams {
  email: string;
}

export interface IConfirmForgotPasswordParams {
  email: string;
  code: string;
  newPassword: string;
}

class AuthService {
  signIn({ email, password }: ISignInParams): Promise<ISignInResponse> {
    return httpClient.post<ISignInParams, ISignInResponse>('auth/signin', {
      email,
      password,
    });
  }

  signUp(params: ISignUpParams): Promise<void> {
    return httpClient.post('auth/signup', params);
  }

  signOut(): Promise<void> {
    return httpClient.post('auth/signout');
  }

  confirmSignup(params: ISignUpConfirmationParams): Promise<void> {
    return httpClient.post('auth/signup/confirm', params);
  }

  resendCode(params: { email: string }): Promise<void> {
    return httpClient.post('auth/signup/resend', params);
  }

  forgotPassword(params: IForgotPasswordParams): Promise<void> {
    return httpClient.post('auth/forgot-password', params);
  }

  confirmForgotPassword(params: IConfirmForgotPasswordParams): Promise<void> {
    return httpClient.post('auth/confirm-forgot-password', params);
  }
}

export default new AuthService();
